const ErrorConfirmacion = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h1 className="text-3xl font-bold text-red-600 mb-4">Error al confirmar la cuenta</h1>
      <p className="text-lg text-gray-700">El token es inválido o ha expirado. Solicita uno nuevo.</p>
    </div>
  );
};

export default ErrorConfirmacion;
